import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import './InExpertiseApplicationsInternalExpert.css';
import SignatureApplicationModal from '../pages/modals/SignatureApplicationModal';
import ApplicationDetailsModal from './modals/ApplicationDetailsModal';
import ChatBox from './modals/ChatBox';
import ApplicationReviewModal from "./modals/ApplicationReviewModal";

import { ClipboardCheck, FileText, FileCheck2 } from 'lucide-react';


export default function InExpertiseApplicationsInternalExpert({ locale }) {
  const [applications, setApplications] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [experts, setExperts] = useState([]);
  const [finalAverage, setFinalAverage] = useState(null);
  const [summaryDecision, setSummaryDecision] = useState('');
  const [loading, setLoading] = useState(true);
  const [finalDecisionUrl, setFinalDecisionUrl] = useState(null);
  const token = localStorage.getItem('token');
  const [finalFile, setFinalFile] = useState(null);
  const [finalUploaded, setFinalUploaded] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [signatureApplication, setSignatureApplication] = useState(null);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [signatures, setSignatures] = useState([]);
  const [pendingSignatures, setPendingSignatures] = useState([]);
  const [finalDocInfo, setFinalDocInfo] = useState(null); // финальный документ (id и т.п.)
  const [finalPdfCached, setFinalPdfCached] = useState(null); // base64 + имя (кастомно, опционально)

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;
  const [finalDocuments, setFinalDocuments] = useState([]);
  const [uploadedInfo, setUploadedInfo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showExpertModal, setShowExpertModal] = useState(false);
  const [showChatBox, setShowChatBox] = useState(false);
  const [scientistDecisionsMap, setScientistDecisionsMap] = useState({});
  const currentScientistDecisions =
    scientistDecisionsMap[selectedApplication?.id] || [];
  const [sendLoading, setSendLoading] = useState(false);
  const navigate = useNavigate();

  const t = {
    kz: {
      applications: 'Сараптамадағы Өтінімдер',
      loading: 'Жүктелуде...',
      view: 'Көру',
      mistakesFile: 'Ескертулер',
      decisionFile: 'Шешім',
      generate: 'Қорытынды жасау',
      sending: 'Жіберілуде...',
      sentOk: '✅ Құжат жіберіліп, сәтті жасалды',
      finalCreated: '✅ Финалдық құжат жасалды. Бөлім басшысының бекітуі күтілуде.',
      genError: '❌ Генерация қателігі',
      close: 'Жабу',
      tableHeaders: {
        publisher: 'Баспа',
        title: 'Оқу басылымы',
        subject: 'Пән',
        grade: 'Сынып',
        language: 'Әзірлеу тілі',
        category: 'Санат',
        action: 'Әрекет',
        expert: 'Сарапшы',
        status: 'Статус',
        averageScore: 'Орташа балл',
        finalAverage: 'Жалпы орташа балл',
        summaryDecision: 'Қорытынды',
        actionsTitle: 'Қорытынды әрекеттері',
        downloadDecision: 'Қорытындыны жүктеу',
        uploadDecision: 'Қорытындылау (шешім)',
        promoteToEvaluation: 'Бағалау кезеңіне өткізу',
      },
      modal: {
        uploadTitle: 'Финалдық құжатты жүктеу',
        selectFile: 'Word-файл (.doc немесе .docx):',
        upload: 'Жүктеу',
        sendAndGenerate: 'Жіберу (құжатты генерациялау)',
        error: 'Қате орын алды',
        uploadSuccess: '✅ Файл сәтті жүктелді',
        uploadError: '❌ Жүктеу қатесі',
        generateSuccess: '✅ Құжат жасалды',
        generateError: '❌ Генерация қатесі',
        downloadError: 'Файлды жүктеу кезінде қате шықты.',
        fileCreated: 'Қорытынды файл сәтті жасалды!',
        errorOccurred: 'Қате орын алды.',
        finalTable: {
          title: 'Финалдық құжаттар',
          file: 'Файл',
          avgScore: 'Орташа балл',
          verdict: 'Қорытынды',
          created: 'Уақыты',
          status: 'Статус',
          reason: 'Себебі',
        }
      },
      statusMap: {
        черновик: 'Аяқталды',
        қайтарылды: 'Қайтарылды',
        бекітілді: 'Бекітілді',
        өңдеуде: 'Өңдеуде',
        аяқталды: 'Аяқталды',
        ожидание_руководителя: 'Бөлім басшысын күтуде',
      },

    },
    ru: {
      applications: 'Заявки на экспертизе',
      loading: 'Загрузка...',
      view: 'Просмотр',
      mistakesFile: 'Замечание',
      decisionFile: 'Решение',
      generate: 'Сформировать итог',
      close: 'Закрыть',
      sending: 'Отправка...',
      sentOk: '✅ Документ отправлен и успешно создан',
      finalCreated: '✅ Финальный документ создан. Ожидается утверждение руководителя.',
      genError: '❌ Ошибка генерации',
      finalTable: {
        title: 'Финальные документы',
        file: 'Файл',
        avgScore: 'Средний балл',
        verdict: 'Заключение',
        created: 'Время',
        status: 'Статус',
        reason: 'Причина',
      },

      tableHeaders: {
        publisher: 'Издательство',
        title: 'Учебное издание',
        subject: 'Предмет',
        grade: 'Класс',
        language: 'Язык разработки',
        category: 'Категория',
        action: 'Действие',
        expert: 'Эксперт',
        status: 'Статус',
        averageScore: 'Средний балл',
        finalAverage: 'Общий средний балл',
        summaryDecision: 'Заключение',
        actionsTitle: 'Действия по итогам',
        downloadDecision: 'Скачать итог',
        uploadDecision: 'Загрузить итог (решение)',
        promoteToEvaluation: 'На след этап оценивание',
      },
      modal: {
        uploadTitle: 'Загрузка финального документа',
        selectFile: 'Word-файл (.doc или .docx):',
        upload: 'Загрузить',
        sendAndGenerate: 'Отправить (сгенерировать документ)',
        error: 'Произошла ошибка',
        uploadSuccess: '✅ Файл успешно загружен',
        uploadError: '❌ Ошибка загрузки',
        generateSuccess: '✅ Документ создан',
        generateError: '❌ Ошибка генерации',
        downloadError: 'Ошибка при загрузке файла.',
        fileCreated: 'Файл решения успешно создан!',
        errorOccurred: 'Произошла ошибка.',
        finalTable: {
          title: 'Финальные документы',
          file: 'Файл',
          avgScore: 'Средний балл',
          verdict: 'Заключение',
          created: 'Время',
          status: 'Статус',
          reason: 'Причина',
        }
      },
      statusMap: {
        черновик: 'Закончился',
        қайтарылды: 'Возвращено',
        бекітілді: 'Утверждено',
        өңдеуде: 'В обработке',
        аяқталды: 'Завершено',
        ожидание_руководителя: 'Ожидает руководителя',
      },

    }
  }[locale] || {};

  // локализация статусов внешних экспертов (ячейка "Статус")
  const EXPERT_STATUS_I18N = {
    kz: {
      'бағалау': 'Бағалау',
      'қателерді анықтау': 'Қателерді анықтау',
      'қате анықтау аяқталды': 'Қате анықтау аяқталды',
      'жіберілді': 'Жіберілді',
      'аяқталды': 'Аяқталды',
      'қорытындылау': 'Қорытындылау',
      'бекітілді': 'Бекітілді',
      'өңдеуде': 'Өңдеуде',
      'ожидание_руководителя': 'Бөлім басшысын күтуде',
    },
    ru: {
      'бағалау': 'Оценка',
      'қателерді анықтау': 'Выявление ошибок',
      'қате анықтау аяқталды': 'Выявление ошибок завершено',
      'жіберілді': 'Отправлено',
      'аяқталды': 'Завершено',
      'қорытындылау': 'Формирование итога',
      'бекітілді': 'Утверждено',
      'өңдеуде': 'В обработке',
      'ожидание_руководителя': 'Ожидает руководителя',
    },
  };

  const trExpertStatus = (raw) => {
    const key = String(raw ?? '').trim().toLowerCase();
    return EXPERT_STATUS_I18N[locale]?.[key] || raw; // fallback — как пришло
  };

  // Нормализатор уже есть ниже, но вынесем наверх,
  // либо используй существующий norm(s)
  const norm = (s) => (s || '').toString().trim().toLowerCase();

  // Локализация вердиктов (обе стороны: RU<->KZ)
  const VERDICT_I18N = {
    ru: {
      'требует доработки': 'Требует доработки',
      'өңдеуді талап етеді': 'Требует доработки',

      'утвердить': 'Утвердить',
      'бекітілсін': 'Утвердить',

      'отклонить': 'Отклонить',
      'қайтарылсын': 'Отклонить',

      // добавляй при появлении новых значений
    },
    kz: {
      'требует доработки': 'Өңдеуді талап етеді',
      'өңдеуді талап етеді': 'Өңдеуді талап етеді',

      'утвердить': 'Бекітілсін',
      'бекітілсін': 'Бекітілсін',

      'отклонить': 'Қайтарылсын',
      'қайтарылсын': 'Қайтарылсын',
    },
  };

  // Универсальная функция перевода вердиктов
  const trVerdict = (raw) => {
    const key = norm(raw);
    const table = VERDICT_I18N[locale === 'ru' ? 'ru' : 'kz'];
    return table[key] || raw; // если не знаем — показываем как пришло
  };



  // над функциями, рядом с t
  const MSG = {
    promoteSuccess: {
      kz: 'Барлық сарапшылар бағалау кезеңіне өтті',
      ru: 'Все эксперты переведены на этап оценки',
    },
    promoteError: {
      kz: 'Қате орын алды',
      ru: 'Произошла ошибка',
    }
  };

  // Content-Disposition-тен файл атын алу
  // Файл атауын анықтау утилиті
  const getFilenameFromDisposition = (disposition) => {
    if (!disposition) return null;
    const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(disposition);
    try {
      return decodeURIComponent(m?.[1] || m?.[2] || '');
    } catch {
      return m?.[1] || m?.[2] || 'file.docx';
    }
  };

  const downloadFinalPdfById = async (finalDocId) => {
    if (!finalDocId) return alert(t?.modal?.errorOccurred || 'Қате орын алды');

    try {
      const res = await axios.get(`/final-documents/download-pdf/${finalDocId}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });

      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `final_document_${finalDocId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('downloadFinalPdfById error:', err);
      alert(t?.modal?.downloadError || 'Жүктеу қатесі');
    }
  };

  // 📎 Архивный документ (attachment) по finalDocId
  const downloadArchiveAttachmentById = async (finalDocId) => {
    if (!finalDocId) return alert(t?.modal?.errorOccurred || 'Қате орын алды');

    try {
      const res = await axios.get(`/documents/download-attachment/${finalDocId}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });

      const filename =
        getFilenameFromDisposition(res.headers?.['content-disposition']) ||
        `archive_attachment_${finalDocId}.pdf`;

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('downloadArchiveAttachmentById error:', err);
      alert(t?.modal?.downloadError || 'Жүктеу қатесі');
    }
  };




  // 🟩 Финалдық құжатты жүктеу (applicationId бойынша)
  const downloadFinalDoc = async (applicationId) => {
    try {
      const res = await axios.get(`/external-expert/final-docs/${applicationId}/download`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });

      const filename =
        getFilenameFromDisposition(res.headers['content-disposition']) ||
        `final_document_${applicationId}.docx`;

      const url = URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('❌ downloadFinalDoc error:', e);
      alert(t?.modal?.downloadError || 'Жүктеу қатесі');
    }
  };


  // [API] Қосымша тіркеме (final_attachment) бар болса — соны жүктеу
  const downloadFinalAttachment = async (docId) => {
    try {
      const res = await axios.get(`/expertise/internal/final-documents/${docId}/attachment`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });

      const filename =
        getFilenameFromDisposition(res.headers['content-disposition']) ||
        `final_attachment_${docId}.docx`;

      const url = URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('❌ downloadFinalAttachment error:', e);
      alert(t?.modal?.downloadError || 'Жүктеу қатесі');
    }
  };

  // подтянуть чат (решение учёного + отзывы двух педагогов)
  const refreshScientistDecisions = async () => {
    if (!selectedApplication?.id) return;
    try {
      const res = await axios.get(
        `/external-expert/scientist-decisions/by-application/${selectedApplication.id}/full`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = res.data?.data || [];
      setScientistDecisionsMap(prev => ({ ...prev, [selectedApplication.id]: data }));
    } catch (e) {
      console.error('❌ refreshScientistDecisions error:', e);
    }
  };

  // открыть модалку подписи "Қол қою / Подписать"
  const openSignature = async (app) => {
    try {
      setSignatureApplication(app);

      // 1. получаем прогресс (средний балл, вердикт)
      const progRes = await axios.get(
        `/expertise/internal/applications/${app.id}/external-progress`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setFinalAverage(progRes.data?.final_average || '');
      setSummaryDecision(progRes.data?.summary_decision || '');

      // 2. получаем список финальных документов по заявке
      const docsRes = await axios.get(
        `/expertise/internal/final-documents/${app.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const docs = docsRes.data?.documents || [];
      const doc = docs[0];
      if (!doc) {
        alert(locale === 'kz'
          ? '❌ Финалдық документ табылмады'
          : '❌ Финальный документ не найден');
        setShowSignatureModal(false);
        return;
      }

      setFinalDocInfo(doc); // сохранили сам документ (в т.ч. id)

      // 3. подписанты
      const sigRes = await axios.get(
        `/final-documents/${doc.id}/signatures/status`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSignatures(sigRes.data?.signers || []);
      setPendingSignatures(sigRes.data?.not_signed || []);

      // 4. pdf base64 (опционально — кэш на случай предпросмотра)
      try {
        const base64Res = await axios.get(
          `/final-documents/${doc.id}/base64`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setFinalPdfCached({
          base64: base64Res.data?.base64 || base64Res.data?.file_base64,
          filename: base64Res.data?.filename || `final_${doc.id}.pdf`,
        });
      } catch (err) {
        // не блокируем модалку, если pdf не дали
        console.warn('pdf base64 load error:', err);
      }

      // 5. показываем модалку
      setShowSignatureModal(true);

    } catch (err) {
      console.error('openSignature error:', err);
      alert(locale === 'kz'
        ? 'Қол қою деректерін жүктеу қатесі'
        : 'Ошибка загрузки данных подписи');
      setShowSignatureModal(true); // всё равно откроем, просто без кнопки подписи
    }
  };


  // скачать файл решения учёного по id
  const downloadScientistDecisionFile = async (decisionId) => {
    try {
      const res = await axios.get(
        `/external-expert/scientist-decisions/${decisionId}/download`,
        { responseType: 'blob', headers: { Authorization: `Bearer ${token}` } }
      );
      const blob = new Blob([res.data], { type: res.headers['content-type'] });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `scientist-decision-${decisionId}.docx`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error('❌ downloadScientistDecisionFile error:', e);
      alert(t.modal.downloadError);
    }
  };

  const handleSendAndGenerate = async () => {
    if (!finalUploaded || !selectedApplication?.id) return;
    setSendLoading(true);
    try {
      const res = await axios.post(
        `internal-expert/final-documents/generate/${selectedApplication.id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // ✅ алерт строго по текущему языку
      alert(`${t.sentOk}\n${t.finalCreated}`);

      if (res?.data?.file) {
        const downloadUrl = `${import.meta.env.VITE_API_URL || 'https://expertise.gov.kz'}/storage/${res.data.file}`;
        window.open(downloadUrl, '_blank');
      }

      await openApplication(selectedApplication); // обновим таблицу

      // закрыть модалку и очистить состояние
      setShowUploadModal(false);
      setFinalFile(null);
      setFinalUploaded(false);
    } catch (err) {
      const serverErr = err?.response?.data?.message?.trim();
      alert(serverErr ? `${t.genError}\n${serverErr}` : t.genError);
      console.error('generate error:', err);
    } finally {
      setSendLoading(false);
    }
  };



  // --- Аккордеон групп (internal expert) ---
  const [expanded, setExpanded] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('iei_expanded_groups') || '{}');
    } catch {
      return {};
    }
  });


  const totalPages = Math.ceil(applications.length / itemsPerPage);
  const paginatedApplications = applications.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );




  const fetchApplications = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/expertise/internal/in-expertise-applications', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setApplications(res.data.applications || []);
    } catch (err) {
      console.error(`${t.modal.error}:`, err);

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedApplication?.id) return;
    const interval = setInterval(() => {
      const list = scientistDecisionsMap[selectedApplication.id] || [];
      const hasSent = list.some(
        x => (x?.decision?.status || '').toLowerCase().trim() === 'жіберілді'
      );
      if (hasSent) refreshScientistDecisions();
    }, 10000); // каждые 10 сек
    return () => clearInterval(interval);
  }, [selectedApplication?.id, scientistDecisionsMap]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get('/internal/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCurrentUserId(res.data?.id);
      } catch (e) {
        console.error('profile error', e);
      }
    })();
  }, []);


  const openApplication = async (app) => {
    setSelectedApplication(app);
    try {
      const res = await axios.get(`/expertise/internal/applications/${app.id}/external-progress`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setExperts(res.data.experts || []);
      setFinalAverage(res.data.final_average);
      setSummaryDecision(res.data.summary_decision);

      // ✅ Подгружаем финальные документы
      const docsRes = await axios.get(`/expertise/internal/final-documents/${app.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFinalDocuments(docsRes.data.documents || []);
    } catch (err) {
      console.error('Қате:', err);
    }
    await refreshScientistDecisions();
  };

  const getMyActiveDecisionObj = () => {
    const list = scientistDecisionsMap[selectedApplication?.id] || [];
    const pendingForMe = list.find(x => (x.reviews || []).some(r => String(r.reviewer_id) === String(currentUserId) && !r.decision));
    if (pendingForMe) return pendingForMe;
    const sent = list.find(x => ['жіберілді', 'отправлено'].includes(norm(x?.decision?.status)));
    return sent || list[0] || null;
  };
  const getMyReviewEntry = (latest) => {
    if (!latest) return null;
    return (latest.reviews || []).find(r => String(r.reviewer_id) === String(currentUserId)) || null;
  };

  // уже отвечал ли текущий пользователь?
  const latestForMe = getMyActiveDecisionObj();
  const mySlot = getMyReviewEntry(latestForMe);
  const alreadyReviewedMe = !!(mySlot?.decision || (mySlot?.comment && mySlot.comment.trim()));


  const openApplicationModal = (app) => {
    setSelectedApplication(app);
    setShowModal(true);
  };
  const closeApplicationModal = () => {
    setIsModalOpen(false);
    setSelectedApplication(null);
  };


  const generateFinalDecision = async (applicationId) => {
    try {
      await axios.post(`/expertise/internal/applications/${applicationId}/decision`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert(t.modal.fileCreated);

    } catch (err) {
      console.error('Қате:', err);
      alert(t.modal.errorOccurred);

    }
  };
  const downloadFinalDecision = async (applicationId) => {
    try {
      const res = await fetch(`https://expertise.gov.kz/api/external-expert/scientist-decisions/by-application/${applicationId}/download`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) {
        const error = await res.json();
        return alert(`❌ ${error.message || t?.modal?.errorOccurred || 'Қате орын алды'}`);
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Ғалым_шешімі.docx';
      document.body.appendChild(link); // Firefox үшін
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Қате:', err);
      alert(t.modal.downloadError);

    }
  };

  const fetchExperts = async (applicationId) => {
    try {
      const res = await axios.get(`/internal-expert/external-experts/${applicationId}`);
      setExperts(res.data);
    } catch (err) {
      console.error('❌ Сарапшыларды алу кезінде қате:', err);
    }
  };

  const promoteToEvaluation = async (applicationId) => {
    try {
      const res = await axios.post(
        `expertise/internal/internal-applications/${applicationId}/promote-to-evaluation`
      );

      const serverMsg = res?.data?.message && String(res.data.message).trim();
      const kz = serverMsg || MSG.promoteSuccess.kz;
      const ru = MSG.promoteSuccess.ru;

      alert(`${kz}\n${ru}`);

      // 🔽 закрываем модалку и приводим UI в порядок
      setShowChatBox(false);
      setSelectedApplication(null);   // <-- это закроет модалку
      setExperts([]);
      // при необходимости — обновим список/прогрессы
      fetchApplications();            // опционально, если хочешь сразу обновить список
      // или точечно: await fetchExperts(applicationId);

    } catch (error) {
      const serverErr = error?.response?.data?.message && String(error.response.data.message).trim();
      const kz = serverErr || MSG.promoteError.kz;
      const ru = MSG.promoteError.ru;
      alert(`${kz}\n${ru}`);
    }
  };




  const downloadExternalExpertDecision = async (externalExpertId) => {
    try {
      const res = await axios.get(`/expertise/internal/external-experts/${externalExpertId}/decision/download`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `external_expert_decision_${externalExpertId}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error('Қате:', err);
      alert(t.modal.downloadError);

    }
  };

  // 1. Қате файлын жүктеу
  const downloadMistakesFile = async (applicationId, expertId) => {
    try {
      const res = await axios.get(`/expertise/internal/applications/${applicationId}/external-experts/${expertId}/mistakes/download`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `қате_файлы_${expertId}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error('❌ Қате файл жүктеу қатесі:', err);
      alert('Қате файлды жүктеу мүмкін болмады');
    }
  };


  // 2. Шешім файлын жүктеу
  const downloadDecisionFile = async (applicationId, expertId) => {
    try {
      const res = await axios.get(`/expertise/internal/applications/${applicationId}/external-experts/${expertId}/decision/download`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `шешім_файлы_${expertId}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error('❌ Шешім файл жүктеу қатесі:', err);
      alert('Шешім файлды жүктеу мүмкін болмады');
    }
  };


  const uploadFinalAttachment = async (applicationId) => {
    const formData = new FormData();
    formData.append('file', finalFile);

    try {
      const res = await axios.post(
        `internal-expert/final-docs/${applicationId}/upload-and-generate`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      alert(t.modal.uploadSuccess);
      setFinalUploaded(true);

      setUploadedInfo({
        uploaded_by: res.data.uploaded_by || 'Сіз',
        uploaded_at: res.data.uploaded_at || new Date().toLocaleString(),
        filename: res.data.filename || finalFile.name,
      });
    } catch (err) {
      alert(`${t.modal.uploadError}: ${err.response?.data?.message || err.message}`);
    }
  };

  const generateFinalAttachment = async (applicationId) => {
    try {
      const res = await axios.post(
        `/internal-expert/final-documents/generate/${applicationId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      alert(res.data.message || t.modal.generateSuccess);

    } catch (err) {
      alert(`${t.modal.generateError}: ${err.response?.data?.message || err.message}`);
    }
  };


  // ✅ Генерациялау және "Зам2-ге жіберу"
  const sendToZam2 = async (applicationId) => {
    try {
      const res = await axios.post(`/internal-expert/final-documents/generate/${applicationId}`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      console.log(res.data);
      alert(res.data.message);
      setSelectedApplication(null);
    } catch (err) {
      alert(err.response?.data?.message || t.modal.generateError);

    }
  };

  // 🔁 обновляем данные при смене языка
  useEffect(() => {
    fetchApplications();
  }, [locale]);

  // 🔁 обновляем данные открытой заявки
  useEffect(() => {
    if (selectedApplication) {
      openApplication(selectedApplication);
    }
  }, [locale]);

  // 🔁 обновляем чат если он открыт
  useEffect(() => {
    if (showChatBox && selectedApplication) {
      refreshScientistDecisions();
    }
  }, [locale]);

  // при смене списка групп — добавляем недостающие ключи в expanded
  useEffect(() => {
    setExpanded(prev => {
      const next = { ...prev };
      (applications || []).forEach(g => {
        const id = g.group_id ?? g.id;
        if (typeof next[id] === 'undefined') next[id] = false;
      });
      return next;
    });
  }, [applications]);

  // сохраняем expanded в localStorage
  useEffect(() => {
    localStorage.setItem('iei_expanded_groups', JSON.stringify(expanded));
  }, [expanded]);

  // переключение одной группы
  const toggleGroup = (id) => setExpanded(p => ({ ...p, [id]: !p[id] }));



  if (loading) return <p>{t.loading}</p>;

  return (

    <div className="iei-container">
      {/* 🔧 Тулбар с массовым раскрытием/сворачиванием для текущей страницы */}
      <div className="gai-toolbar" style={{ marginBottom: 10 }}>
        {(() => {
          const anyOpen = (paginatedApplications || []).some(g => expanded[g.group_id ?? g.id]);
          const label = anyOpen
            ? (locale === 'ru' ? 'Свернуть все' : 'Барлығын жабу')
            : (locale === 'ru' ? 'Развернуть все' : 'Барлығын ашу');

          const toggleAllGroups = () => {
            const target = !anyOpen;
            setExpanded(prev => {
              const next = { ...prev };
              (paginatedApplications || []).forEach(g => {
                next[g.group_id ?? g.id] = target;
              });
              return next;
            });
          };

          return (
            <button className="btn-secondary" onClick={toggleAllGroups}>
              {label}
            </button>
          );
        })()}
      </div>

      {/* ♻️ Используем ИМЕННО paginatedApplications */}
      {paginatedApplications.map((group, gIdx) => {
        const gid = group.group_id ?? group.id ?? gIdx;
        const isOpen = !!expanded[gid];
        const panelId = `iei-panel-${gid}`;
        const headerId = `iei-head-${gid}`;

        const onHeaderKeyDown = (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleGroup(gid);
          }
        };

        return (
          <div key={gid} className={`iei-group ${isOpen ? 'is-open' : 'is-closed'} mb-8`}>
            {/* Шапка — кликабельная */}
            <div
              id={headerId}
              role="button"
              tabIndex={0}
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => toggleGroup(gid)}
              onKeyDown={onHeaderKeyDown}
              className="iei-head"
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                cursor: 'pointer', padding: '10px 12px',
                background: '#f3f4f6', borderRadius: 8
              }}
            >
              <span style={{ fontSize: 18, lineHeight: 1 }}>{isOpen ? '▾' : '▸'}</span>
              <h2 className="text-xl font-semibold text-blue-700">
                {group.group_title}
              </h2>
            </div>

            {/* Панель — показываем только если раскрыто */}
            {isOpen && (
              <div id={panelId} role="region" aria-labelledby={headerId} className="iei-panel" style={{ marginTop: 10 }}>
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th>{t.tableHeaders.publisher}</th>
                      <th>{t.tableHeaders.title}</th>
                      <th>{t.tableHeaders.subject}</th>
                      <th>{t.tableHeaders.grade}</th>
                      <th>{t.tableHeaders.language}</th>
                      <th>{t.tableHeaders.category}</th>
                      <th>{t.tableHeaders.action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {group.applications.map((app) => (
                      <tr key={app.id}>
                        <td>{app.publisher}</td>
                        <td>{app.title}</td>
                        <td>{app.subject}</td>
                        <td>{app.grade}</td>
                        <td>{app.development_language}</td>
                        <td>{app.category}</td>
                        <td style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '6px',
                          justifyContent: 'flex-start'
                        }}>
                          <button
                            className="btn-primary"
                            onClick={() => openApplication(app)}
                          >
                            {t.view}
                          </button>

                          <button
                            className="btn-primary"
                            style={{ backgroundColor: '#4caf50', borderColor: '#4caf50' }}
                            onClick={() => openSignature(app)}
                          >
                            {locale === 'kz' ? 'Қол қою' : 'Подписать'}
                          </button>
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}

      {selectedApplication && (
        <ApplicationReviewModal
          isOpen
          application={selectedApplication}
          experts={experts}
          locale={locale}
          t={t}
          finalAverage={finalAverage}
          summaryDecision={summaryDecision}
          finalDocuments={finalDocuments}

          // форматтеры
          trExpertStatus={trExpertStatus}
          trVerdict={trVerdict}

          // базовые действия
          onClose={() => setSelectedApplication(null)}
          onOpenChat={async () => {
            await refreshScientistDecisions();
            setShowChatBox(true);
          }}

          onOpenErrorReview={() =>
  navigate(
    `/error-review/${selectedApplication.id}?role=viewer&locale=${locale}`
  )
}

          // файлы экспертов
          downloadMistakesFile={downloadMistakesFile}
          downloadDecisionFile={downloadDecisionFile}

          // изменение статуса
          promoteToEvaluation={promoteToEvaluation}

          // финальные документы
          downloadFinalDecision={downloadFinalDecision}
          downloadFinalDoc={downloadFinalDoc}
          downloadFinalAttachment={downloadFinalAttachment}

          // загрузка финального файла
          showUploadModal={showUploadModal}
          setShowUploadModal={setShowUploadModal}
          finalFile={finalFile}
          setFinalFile={setFinalFile}
          finalUploaded={finalUploaded}
          setFinalUploaded={setFinalUploaded}
          uploadFinalAttachment={uploadFinalAttachment}
          handleSendAndGenerate={handleSendAndGenerate}
          sendLoading={sendLoading}

          // чат
          ChatBoxComponent={ChatBox}
          chatBoxProps={{
            isOpen: showChatBox,
            onClose: () => setShowChatBox(false),
            decisions: currentScientistDecisions,
            lang: locale === "kz" ? "kk" : "ru",
            onDownloadDecisionFile: downloadScientistDecisionFile,
            currentUserId,
            alreadyReviewed: alreadyReviewedMe,
            isScientist: false,
            // ваш текущий обработчик отправки:
            onSubmitReview: async (decision, commentText, reviewIdFromChild) => {
              const latest = getMyActiveDecisionObj();
              const reviewId = reviewIdFromChild || latest?.decision?.id;
              if (!reviewId) {
                alert(locale === "kz" ? "Қате: шешім табылмады" : "Ошибка: не найден ID решения");
                return;
              }
              try {
                await axios.post(
                  `/external-expert/scientist-decisions/${reviewId}/review`,
                  { decision, comment: commentText },
                  { headers: { Authorization: `Bearer ${token}` } }
                );
                alert(locale === "kz" ? "✅ Жауап сақталды" : "✅ Ответ сохранён");
                await refreshScientistDecisions();
              } catch (err) {
                const status = err?.response?.status;
                if (status === 403) alert(locale === "kz" ? "403: Рұқсат жоқ" : "403: Нет прав");
                else if (status === 401) alert(locale === "kz" ? "401: Сессия аяқталды" : "401: Сессия истекла");
                else alert(locale === "kz" ? "Қате орын алды" : "Произошла ошибка");
                console.error("review post error:", err);
              }
            },
          }}
        />
      )}

      {showExpertModal && selectedApplication && (
        <ApplicationDetailsModal
          application={selectedApplication}
          onClose={() => {
            setSelectedApplication(null);
            setShowExpertModal(false);
          }}
          t={t}
        />
      )}

      {showSignatureModal && signatureApplication && (
        <SignatureApplicationModal
          application={signatureApplication}
          onClose={() => {
            setShowSignatureModal(false);
            setSignatureApplication(null);
            
          }}
          locale={locale}

          // данные о документе / решении
          finalAverage={finalAverage}
          summaryDecision={summaryDecision}
          isInternalExpert={true}



          // минимальный t, потому что SignatureApplicationModal ожидает t.average / t.decision / t.signatures / t.download
          t={{
            average: locale === 'kz' ? 'Орташа балл' : 'Средний балл',
            decision: locale === 'kz' ? 'Қорытынды' : 'Решение',
            signatures: locale === 'kz' ? 'Қол қою тізімі' : 'Список подписантов',
            download: locale === 'kz'
              ? 'Баспаға кететін құжатты жүктеу'
              : 'Скачать документ для издательства',
            downloadArchive: locale === 'kz'
              ? 'Архивке кететін құжатты жүктеу'
              : 'Скачать документ для архива',
          }}


          token={token}

          // очень важно: кто я
          userId={currentUserId}

          // ID финального документа (для PUT /final-documents/sign/:id и GET /final-documents/:id/base64 внутри модалки)
          finalDocumentId={finalDocInfo?.id}
          downloadFinalDecision={(finalDocId) => downloadFinalPdfById(finalDocId)}
          downloadArchiveAttachment={(finalDocId) => downloadArchiveAttachmentById(finalDocId)}



          // кешированный pdf base64 (не обязателен, но можно передать)
          base64File={finalPdfCached?.base64}
          base64Filename={finalPdfCached?.filename}

          // статусы подписантов
          signatures={signatures}
          pendingSignatures={pendingSignatures}

          // колбек если подписали успешно
      onSignedSuccess={async () => {
  if (finalDocInfo?.id) {
    try {
      const sigRes = await axios.get(
        `/final-documents/${finalDocInfo.id}/signatures/status`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSignatures(sigRes.data?.signers || []);
      setPendingSignatures(sigRes.data?.not_signed || []);
    } catch (err) {
      console.error('refresh signatures error:', err);
    }
  }
}}

          onSignedFail={(msg) => {
            alert(msg || (locale === 'kz'
              ? 'Қол қою қатесі'
              : 'Ошибка при подписи'));
          }}

          // чтобы модалка могла рефрешнуть сама после подписи (мягко)
          refreshApplication={async () => {
            if (!finalDocInfo?.id) return;
            try {
              const sigRes = await axios.get(
                `/final-documents/${finalDocInfo.id}/signatures/status`,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              setSignatures(sigRes.data?.signers || []);
              setPendingSignatures(sigRes.data?.not_signed || []);
            } catch (err) {
              console.error('refreshApplication error', err);
            }
          }}
        />
      )}




      {/* 🔽 Пагинация */}
      <div className="pagination mt-4 flex justify-center items-center gap-2">
        <button
          className="btn-secondary"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          ⬅️
        </button>
        <span>
          {currentPage} / {totalPages}
        </span>
        <button
          className="btn-secondary"
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          ➡️
        </button>
      </div>


    </div>
  );
}